import React from 'react'

const VerticalNavMenuSectionHeader = ({ item }) => {
  return (
    <li className="navigation-header !m-[0px] !mx-[8px]">
      <span className="text-truncate text-[var(--nav-text)]">{item.header}</span>
    </li>
  )
}

export default VerticalNavMenuSectionHeader
